import React from 'react';
import { Route, Switch } from 'react-router';
import PrivateRoute from './PrivateRoute.jsx';
import PageError from './PageError.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import Dashboard from '../modules/Dashboard/Dashboard.jsx';
import MainPage from '../modules/Dashboard/MainPage.jsx';
import RouterPaths from './routePaths.js';
import ConfigsLoadable from "../modules/Configs/ConfigsLoadable";
import LoginPageLoadable from "../modules/Auth/components/LoginPageLoadable";
import RegistrationPageLoadable from "../modules/Auth/components/RegistrationPageLoadable";
import LogoutLoadable from "../modules/Auth/components/LogoutLoadable";
import ForgotPage from "../modules/Auth/components/ForgotPage";
import ResetPage from "../modules/Auth/components/ResetPage";
import Transactions from "../modules/Transactions/Transactions";

const RoutePage = () => {
    return <ErrorBoundary>
        <Switch>
            <Route path={RouterPaths.login} component={LoginPageLoadable}/>
            <Route path={RouterPaths.registration} component={RegistrationPageLoadable}/>
            <Route path={RouterPaths.logout} component={LogoutLoadable}/>
            <Route path={RouterPaths.forgot} component={ForgotPage}/>
            <Route path={RouterPaths.reset} component={ResetPage}/>
            <PrivateRoute exact path={RouterPaths.main} component={MainPage} wrapper={Dashboard}/>
            <PrivateRoute path={RouterPaths.transactions} component={Transactions} wrapper={Dashboard}/>
            <PrivateRoute path={RouterPaths.config} component={ConfigsLoadable} wrapper={Dashboard}/>
            <Route path='**' component={PageError}/>
        </Switch>
    </ErrorBoundary>;
};

export default RoutePage;
